import React from "react";

const Payment = () => {
  return (
    <div>
      <h1 className="text-info mt-5 pt-5">Payment System Coming...</h1>
    </div>
  );
};

export default Payment;
